import { render, staticRenderFns } from "./StockManage.vue?vue&type=template&id=07f0f6a6&"
import script from "./StockManage.vue?vue&type=script&lang=js&"
export * from "./StockManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports